import React, { useContext, useEffect, useMemo } from 'react';
import { Route, Switch } from 'react-router-dom';

import { useGuestMessagingStatusesQuery, useWeddingWebsiteQuery } from '../../generated/graphql';
import { messagingHubRoute, sentMessagesRoute } from '../../helpers/routes';
import { TrackingContext } from '../../TrackingContext';
import { TabNav, TabNavItem } from '../TabNav';
import styles from './body.scss';
import Messages from './Messages';
import SentMessages from './SentMessages';
import NameModal from './NameModal';

const Body: React.FC = () => {
  const { setPagesLoaded } = useContext(TrackingContext);
  const { data } = useGuestMessagingStatusesQuery({ errorPolicy: 'all' });
  const { data: memberData, loading } = useWeddingWebsiteQuery();

  useEffect(() => {
    setPagesLoaded(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const anyRequiredFieldsEmpty: boolean = useMemo(() => {
    if (memberData?.member && memberData?.wedding) {
      const { firstName, lastName, fianceFirstName, fianceLastName } = memberData.member;

      // We want to show the modal if any of the required values are incomplete
      return [firstName, lastName, fianceFirstName, fianceLastName].filter(Boolean).length < 4;
    }

    // If no member, handling loading state in the markup
    return true;
  }, [memberData]);

  return (
    <>
      <div className={styles.root}>
        <TabNav>
          <TabNavItem to={messagingHubRoute}>Messages</TabNavItem>
          <TabNavItem to={sentMessagesRoute}>
            Sent Messages {`${data?.guestMessagingStatuses?.length ? `(${data.guestMessagingStatuses.length})` : ''}`}
          </TabNavItem>
        </TabNav>
        {!loading && anyRequiredFieldsEmpty ? (
          <NameModal />
        ) : (
          <div className={styles.container}>
            <Switch>
              <Route exact path={messagingHubRoute}>
                <Messages />
              </Route>
              <Route exact path={sentMessagesRoute} component={SentMessages} />
            </Switch>
          </div>
        )}
      </div>
    </>
  );
};

export default Body;
